/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'anf-core-react';
import { refProp, textProp } from '../../../tools/customProps';
import { Form, FormGroup } from '../../Common/Form';
import * as FormStructure from '../../FormStructure';
import { TmntText } from '../../Common';
import HelpReasonDropDown from './HelpReasonDropDown';
import { emailUsFormTextV2 } from './emailUsPropTypes';
import { useCustomTealiumTrigger } from '../../../hooks/useTealiumTrigger';

export default function EmailUsEntryModal({
  onSuccess,
  children = undefined,
  formRef = undefined,
  label,
  text,
  selectedReason = '',
  selectedReasonKey = '',
  handleHelpReasonChange,
  contactReasonIsInvalid,
  handleOnContinue,
  step,
}) {
  const {
    formFieldDropDown,
    formWhatDoYouNeedHelpWith,
    formContinueButton,
    formGotItButton,
  } = text;

  const analyticsData = {
    eventName: 'universal_click',
    eventData: {
      event_name: 'click',
      tealium_event: 'click',
      data_text: 'email us simple',
      data_action: 'submit',
      reason_for_help: selectedReasonKey,
    },
  };

  const includeDatabridgeDatapoints = false;
  const triggerAnalytics = useCustomTealiumTrigger(analyticsData, includeDatabridgeDatapoints);

  const renderFormPromptText = () => (
    <h3 className="what-do-you-need-help-with">
      <TmntText tmnt={formWhatDoYouNeedHelpWith} />
    </h3>
  );

  const renderHelpReasonDropDown = () => (
    <HelpReasonDropDown
      id="email-us-form__help-reason-dropdown"
      isInvalid={contactReasonIsInvalid}
      onChange={handleHelpReasonChange}
      text={formFieldDropDown}
      value={selectedReason || ''}
    />
  );

  const renderFormLabel = () => (
    <span className="screen-reader-text">
      <TmntText tmnt={label} />
    </span>
  );

  const renderContinueButton = () => (
    <Button
      variant="secondary"
      isFullWidth
      onClick={handleOnContinue}
    >
      <TmntText tmnt={formContinueButton} />
    </Button>
  );

  const renderGotItButton = () => (
    <Button
      variant="secondary"
      isFullWidth
      onClick={() => {
        triggerAnalytics();
        onSuccess();
      }}
    >
      <TmntText tmnt={formGotItButton} />
    </Button>
  );

  const renderButton = () => {
    if (step === 'directions') {
      return renderGotItButton();
    }
    return renderContinueButton();
  };

  const renderFormGroups = () => ([
    <FormGroup
      key="account-form-group-dropdown"
      fields={[renderFormPromptText(), renderHelpReasonDropDown()]}
    />,
  ]);

  return (
    <Form
      id="email-us-form__entry-modal"
      label={renderFormLabel()}
      formRef={formRef}
      groups={renderFormGroups()}
      isInvalid={contactReasonIsInvalid}
      isValidated={false}
    >
      { children }

      <FormStructure.FormGroup>
        <FormStructure.FormCell>
          {renderButton()}
        </FormStructure.FormCell>
      </FormStructure.FormGroup>
    </Form>
  );
}

const propTypes = {
  label: textProp.isRequired,
  text: emailUsFormTextV2.isRequired,
  children: PropTypes.node,
  formRef: refProp,
  selectedReason: PropTypes.string,
  selectedReasonKey: PropTypes.string,
  handleHelpReasonChange: PropTypes.func.isRequired,
  contactReasonIsInvalid: PropTypes.bool.isRequired,
  handleOnContinue: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  step: PropTypes.string.isRequired,
};

EmailUsEntryModal.propTypes = propTypes;
